export const ResearchAmountCrubs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sportello',
    path: '/sportello',
  },
  {
    name: 'Gestione Importo',
    path: '/sportello/ricerca-importo',
  },
];

export const NewAmountCrubs = [
  ...ResearchAmountCrubs,
  {
    name: 'Nuovo Importo',
    path: '/sportello/ricerca-importo/nuovo',
  },
];

export const EditAmountCrubs = [
  ...ResearchAmountCrubs,
  {
    name: 'Modifica Importo',
    path: '/sportello/ricerca-importo/modifica',
  },
];

export const DetailAmountCrubs = [
  ...ResearchAmountCrubs,
  {
    name: 'Dettaglio Importo',
    path: '/sportello/ricerca-importo/dettaglio',
  },
];
